import styled from "styled-components";
import { colours } from "../../styles/colours";

export const H1 = styled.h1`
  font-size: 1.5em;
  font-weight: 500;
`;
export const H2 = styled.h2`
  font-size: 1.125em;
  font-weight: 500;
`;

export const Code = styled.code`
  background-color: ${colours.lightGrey};
  border-radius: 7px;
  padding: 0.3em 0.5em;
  display: inline-block;
  word-break: break-word;
`;
